import { calculatePrice, changeSizeIndex, changeColors, changeLocations, changeZip, changeQuantity, changeShippingCountry, updateEmbellishmentMethod } from './instant-quote.actions';
export const instantQuoteDispatcher = dispatch => ({
  onSubmit: () => {
    dispatch(calculatePrice());
  },
  onQuantityChange: e => {
    dispatch(changeQuantity(parseInt(e.target.value || 0, 10) || 0));
  },
  onColorsChange: (value, index) => {
    dispatch(changeColors(parseInt(value || 0, 10) || 0, index));
  },
  onZipChange: e => {
    dispatch(changeZip(e.target.value));
  },
  onLocationsChange: e => {
    dispatch(changeLocations(parseInt(e.target.value || 0, 10) || 0));
  },
  onSizeIndexChange: sizeIndex => dispatch(changeSizeIndex(sizeIndex)),
  onShippingCountryChange: countryCode => dispatch(changeShippingCountry(countryCode)),
  updateEmbellishmentMethod: embellishmentId => dispatch(updateEmbellishmentMethod(embellishmentId))
});